import { ApiResponse, DelivertyOptionsResponse } from '../models/apiResponse';
import { DeliveryOptionsRequest } from '../models/shipmentCountryInfo';
import { apiRequests as requests } from './http-client';
import { FORTY_FIVE_SECOND_POST_CACHE_CONFIG } from './cache-config';

const Calculator = {
  // step 2 preparation,
  deliveryOptionsV2: (request: DeliveryOptionsRequest) =>
    requests
      .post<
        ApiResponse<DelivertyOptionsResponse>
      >('/v1/calculator/delivery-options-v3', request, FORTY_FIVE_SECOND_POST_CACHE_CONFIG)
      .then((response) => ({
        data: response.data,
        messageBus: response.message_bus ?? [],
      })),
};

export default Calculator;
